import { styled, Tooltip } from "@mui/material";

const TooltipDark = styled(({ className, backgroundColor, variant, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ backgroundColor = "#19191b", variant }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor,
    color: "#ddd9d5",
    margin: 4,
    padding: "4 8",
    border: variant === "outline" ? "1px solid #333" : "none",
    boxShadow: variant === "outline" ? "none" : "0px 0px 8px #00000034",
  },
  [`& .MuiTooltip-arrow`]: {
    color: "#ddd9d5",
    "&::before": {
      backgroundColor,
      border: variant === "outline" ? "1px solid #333" : "none",
      boxShadow: variant === "outline" ? "none" : "0px 0px 2px #00000034",
    },
  },
}));

export default TooltipDark;
